import React from 'react';
import '../App.css';

const logoTravelLeaders = 'https://agents.travelleaders.com/Reviews/images/LogoTL_59.png';

const WrongUrl = () => {
    return (
        <div className="ErrorPage">
            <header className="bg-white shadow-md p-10 text-center relative">
                <a href="https://travelleaders.com" target="_blank" rel="noopener noreferrer">
                    <img
                        src={logoTravelLeaders}
                        alt="Travel Leaders Logo"
                        className="text-center"
                    />
                </a>
            </header>

            <div className="bg-white shadow-md p-20 mt-24 mb-10 w-11/12 max-w-2xl mx-auto text-center relative">
                <div className="relative">
                    <h1 className="text-3xl mb-2 pb-4 text-tlBlue">Oops, looks that you are lost!</h1>
                    <h2 className="text-lg mb-2">Don't worry, we have plenty of agents to choose.<br />
                        <a className="text-lg mb-2 text-tlBlue" id="lnkFindAgents" href="https://www.travelleaders.com/find_travel_agent\">Find Other Agents Now</a></h2>
                </div>
            </div>
        </div>
    );
};

export default WrongUrl;
